import { Navigate, useLocation } from 'react-router-dom'
import { useAdminAuth } from '../contexts/AdminAuthContext'

interface AdminProtectedRouteProps {
    children: React.ReactNode
}

export default function AdminProtectedRoute({ children }: AdminProtectedRouteProps) {
    const { isAuthenticated, loading } = useAdminAuth()
    const location = useLocation()

    if (loading) {
        return (
            <div className="min-h-screen bg-gray-50 dark:bg-gray-900 flex items-center justify-center">
                <div className="text-center">
                    <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
                    <p className="text-gray-600 dark:text-gray-400">Verificando acesso...</p>
                </div>
            </div>
        )
    }

    if (!isAuthenticated) {
        // Redirecionar para login preservando a URL de destino
        return <Navigate to="/admin/login" state={{ from: location }} replace />
    }

    return <>{children}</>
}

